import React from "react";
import RM from "react-render-markup";
import * as levenshtein from "damerau-levenshtein";
import moment from "moment";
import Chart from "../components/elements/Chart";
import formdata from "../data/formdata";
import slug from "slug";

// https://www.npmjs.com/package/damerau-levenshtein
const distance = (a, b) => levenshtein(a, b);
const getUTC = string => {
  return moment.utc(string, "DD.MM.YYYY");
};
const sortBy = (property, direction = "asc", type = "string") => {
  let sortOrder = direction === "asc" ? 1 : -1;
  let slugConfig = { locale: "de" };
  return (a, b) => {
    let x = type === "date" ? getUTC(a[property]) : slug(a[property], slugConfig);
    let y = type === "date" ? getUTC(b[property]) : slug(b[property], slugConfig);
    let result = x < y ? -1 : x > y ? 1 : 0;
    return result * sortOrder;
  };
};
const compareValues = (key, order = "asc") => {
  return (a, b) => {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
    const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order === "desc" ? comparison * -1 : comparison;
  };
};
const formDate = strg => {
  if (typeof strg === "number") return moment(strg).format("DD.MM.YYYY");
  let temp = strg.indexOf("T") !== -1 ? strg.split("T")[0].split("-") : strg.split("-");
  return `${temp[2]}.${temp[1]}.${temp[0]}`;
};

const convertSpaces = (string, rep = "_") => string.trim().replace(/ /g, rep);

const getValueByKey = (array, key) => {
  let found = formdata[array].filter(item => item[0] === key);
  return found.length ? found[0][1] : "";
};
const getSalutation = strg => {
  if (strg === "d") return "";
  return getValueByKey("salutation", strg);
};
const getInterestGroup = strg => getValueByKey("interest_groups", strg);
const getUserType = strg => {
  let keyword = strg.indexOf("-") !== -1 ? strg.split("-")[1] : strg;
  return getValueByKey("user_types", keyword);
};
const getClientType = strg => getValueByKey("client_types", strg);
const getPdfProvider = strg => getValueByKey("pdfProviders", strg);
const getRegion = strg => getValueByKey("federal_states", strg);
const getUserState = (activated, deleted = false) => {
  if (deleted) return { icon: "fas fa-minus-circle", text: "gelöscht" };
  return {
    icon: activated ? "fas fa-check-circle" : "fas fa-exclamation-circle",
    text: activated ? "aktiviert" : "inaktiv"
  };
};
const getGraduation = (state, grad) => formdata.graduations[state].filter(arr => arr[0] === grad)[0][1];
const getLogEntry = key => getValueByKey("log_types", key);
const getResponse = key => getValueByKey("response_codes", key);
const hasLicenceAssignmentData = logdata => {
  if (!logdata.length) return false;
  // return Boolean(logdata.filter(item => item.type.toLowerCase().includes("licence")).length);
  return Boolean(logdata.filter(item => item.type.toUpperCase() === "INSTITUTION_GOT_LICENCES_ASSIGNED_BY_CLIENT").length);
};
const renderLicenceAssignmentData = logdata => {
  let data = logdata.filter(item => item.type.toUpperCase() === "INSTITUTION_GOT_LICENCES_ASSIGNED_BY_CLIENT");
  let output = data.map((item, index) => (
    <tr key={index}>
      <td>{formDate(item.ts)}</td>
      <td>{getValueByKey("log_types", item.type)}</td>
      <td className="has-text-centered	">{typeof item.data === "object" ? item.data.licencecount : item.data}</td>
      <td>{item.data.validUntil ? formDate(item.data.validUntil) : "—"}</td>
    </tr>
  ));
  return (
    <>
      <p className="title is-5">Lizenzzuweisungen</p>
      <div className="table-container">
        <table className="table is-bordered">
          <thead>
            <tr>
              <th>Datum</th>
              <th>Status</th>
              <th>Anzahl</th>
              <th>Gültig bis</th>
            </tr>
          </thead>
          <tbody>{output}</tbody>
        </table>
      </div>
      <hr />
    </>
  );
};

const dispError = msg => {
  return { type: "notify", msg: { text: msg, type: "error" } };
};
const dispSuccess = msg => {
  return { type: "notify", msg: { text: msg, type: "success" } };
};

const renderLicencePie = licences => {
  let pieSize = 240;
  let labels = ["verbraucht Sek I", "verbraucht Sek II", "zugewiesen", "verfügbar"];
  let segments = [];
  segments.push({ value: Math.round((licences.used_sek1 / licences.total) * 100), className: "lic-used-sek1" });
  segments.push({ value: Math.round((licences.used_sek2 / licences.total) * 100), className: "lic-used-sek2" });
  segments.push({ value: Math.round((licences.assigned / licences.total) * 100), className: "lic-assigned" });
  segments.push({ value: Math.round((licences.available / licences.total) * 100), className: "lic-available" });
  return (
    <Chart
      type="Pie"
      className="licence-pie"
      data={{
        labels: labels,
        series: segments
      }}
      options={{
        // donut: true,
        // donutWidth: 30,
        // startAngle: 270,
        // total: 200,
        // labelOffset: 60,
        // labelDirection: "explode",
        showLabel: false,
        width: pieSize,
        height: pieSize
      }}
      // responsiveOptions={[["screen and (max-width: 640px)", { showLabel: false }]]}
    />
  );
};
const renderLicenceTable = licences => {
  return (
    <table className="table licences">
      <tfoot>
        <tr>
          <th className="initial"></th>
          <th>Gesamt</th>
          <th>{licences.total}</th>
        </tr>
      </tfoot>
      <tbody>
        <tr>
          <td className="initial col-code used-sek1"></td>
          <td>Verbraucht Sek I</td>
          <td>{licences.used_sek1}</td>
        </tr>
        <tr>
          <td className="initial col-code used-sek2"></td>
          <td>Verbraucht Sek II</td>
          <td>{licences.used_sek2}</td>
        </tr>
        <tr>
          <td className="initial col-code assigned"></td>
          <td>Zugewiesen</td>
          <td>{licences.assigned}</td>
        </tr>
        <tr>
          <td className="initial col-code available"></td>
          <td>Verfügbar</td>
          <td>{licences.available}</td>
        </tr>
      </tbody>
    </table>
  );
};
const renderLicenceBar = licences => {
  let content = null;
  if (licences.total < 1) {
    content = <span style={{ width: `100%` }} className={"lic-empty"}></span>;
  } else {
    content = (
      <>
        {licences.used_sek1 > 0 && <span style={{ width: `${Math.round((licences.used_sek1 / licences.total) * 100)}%` }} className={"lic-used-sek1"}></span>}
        {licences.used_sek2 > 0 && <span style={{ width: `${Math.round((licences.used_sek2 / licences.total) * 100)}%` }} className={"lic-used-sek2"}></span>}
        {licences.assigned > 0 && <span style={{ width: `${Math.round((licences.assigned / licences.total) * 100)}%` }} className={"lic-assigned"}></span>}
        {licences.available > 0 && <span style={{ width: `${Math.round((licences.available / licences.total) * 100)}%` }} className={"lic-available"}></span>}
      </>
    );
  }

  return <div className="licence-bar">{content}</div>;
};

const renderMarkup = input => RM(input);

export { getPdfProvider, convertSpaces, getUTC, distance, sortBy, dispError, dispSuccess, getLogEntry, getResponse, getSalutation, getGraduation, getInterestGroup, getUserType, getUserState, getClientType, getRegion, renderLicencePie, renderLicenceTable, renderLicenceBar, renderMarkup, hasLicenceAssignmentData, renderLicenceAssignmentData, compareValues };
